<template>
    <div
        class="g product-list"
    >
        <mdSearch v-if="haveSort || haveFunc">
            <div v-if="haveSort" class="cp input select" :class="[errors.has('sortType')? 'is-error': '']" :data-error="errors.first('sortType')">
                <label for="sortType">{{ $t('site.func.sort') }}</label>
                <select v-model="sortType" v-validate="''" name="sortType" id="sortType">
                    <option value="">{{ $t('site.func.sortdefault') }}</option>
                    <option value="product_s">{{ $t('site.func.sortbyname') }}</option>
                    <option value="price">{{ $t('site.func.sortbyprice') }}</option>
                </select>
            </div>
            <slot name="search"></slot>
            <mdUserFunc
                v-if="haveFunc"
                :node="sortIcon"

                @click="clickFunc"
                @sendEvent="receiveEvent"
            ></mdUserFunc>
        </mdSearch>
        <slot v-else name="search"></slot>
        <slot name="top"></slot>
        <mdProductList
            v-if="pageFilter && pageFilter.length"
            :list="pageFilter"
            :showType="showType"

            @sendEvent="receiveEvent"
        ></mdProductList>
        <div
            v-else
            class="md"
        >
            <cpStatus
                tag="div"
                themes="major"
                icon="warning"
                :text="$t('page.search.status.noresults')"
            ></cpStatus>
        </div>
        <slot name="bottom"></slot>
        <mdPageination
            v-if="showFilter && showFilter.length && havePageination && length > show"
            :page="page"
            :selector="selector"
            :setLength="show"
            :length="length"

            @sendEvent="receiveEvent"
        ></mdPageination>
    </div>
</template>

<script>
    import mdProductList from '@/components/mdProductList'
    import mdPageination from '@/components/mdPageination'
    import mdUserFunc from '@/components/mdUserFunc'
    import mdSearch from '@/components/mdSearch' 
    import cpStatus from '@/components/cpStatus'

    export default {
        components: {
            mdProductList,
            mdPageination,
            mdUserFunc,
            mdSearch,
            cpStatus,
        },
        props: {
            list: {
                type: Array,
                require: true,
                default: function(){
                    return []
                }
            },
            haveSort: { //是否顯示切換排序
                type: Boolean,
                require: false,
                default: true
            },
            haveFunc: { //是否顯示切換樣式
                type: Boolean,
                require: false,
                default: true
            },
            havePageination: { //是否顯示底部分頁
                type: Boolean,
                require: false,
                default: true
            },
            setLength: { //調整 list 一頁的列數
                type: Number,
                require: false,
                default: 10
            },
            selector: { //調整 table 可切換的單頁筆數
                type: Array,
                required: false,
                default: function(){
                    return [10, 20, 50, 100, 200, 500]
                }
            },
            showMode: { //調整顯示模式
                type: String,
                require: false,
                default: 'table'
            },
            pageSet: { //設定 page
                type: Number,
                require: false,
                default: 1
            },
            action: {
                type: Function,
                require: false,
                default: () => {}
            }
        },
        data: function(){
            let _setLength = this.setLength || 10,
                _showMode = this.showMode || 'table';

            return {
                showType: _showMode,
                show: _setLength,
                sortType: '',
                page: this.pageSet,
            }
        },
        computed: {
            content: function(){
                let $content = this.list || []

                return $content;
            },
            sortIcon: function(){

                return [
                    {
                        icon: 'table',
                        active: this.showType === 'table',
                    },
                    {
                        icon: 'list',
                        active: this.showType === 'list',
                    }
                ]
            },
            showFilter: function(){
                let $content = this.content || [],
                    $show = $content.filter(data => data.show === true),
                    _sortType = this.sortType || 'sn';

                $show.sort((a, b) => {
                    let _a = a[_sortType],
                        _b = b[_sortType];

                    if( _sortType === 'price' ) {
                        _a = this.getPrice(a.node);
                        _b = this.getPrice(b.node);
                    }

                    return _a > _b? 1: -1
                });

                $show.forEach((data, _index) => { //init
                    data.page = Math.floor(_index / this.show) + 1;
                });

                return $show;
            },
            pageFilter: function(){

                if( this.havePageination ) {
                    return this.showFilter.filter(data => data.page === this.page);
                }else {
                    return this.showFilter;
                }
            },
            length: function(){
                return this.showFilter.length;
            },
        },
        watch: {
            list: {
                handler: function(){
                    this.initList();
                }
            },
            pageSet: {
                handler: function(){
                    this.page = parseInt(this.pageSet);
                }
            },
        },
        methods: {
            clickFunc: function(obj){
                this.$set(this, 'showType', obj.icon);
            },
            getPrice: function(item) {

                if( item.available && item.available ) {
                    return item.price;
                }else {
                    return 0;
                }
            },
            changeByLength: function(length){ //改一次顯示的數量
                let _length = parseInt(length, 10);

                this.changeByPage(1);
                
                this.show = _length;
            },
            changeByPage: function(page){ //改頁面
                let _page = parseInt(page);

                let _show = this.show;

                if( _page <= Math.ceil(this.length / _show) ){

                    let $_action = this.action;

                    if( $_action && typeof $_action === 'function' ) {
                        $_action(parseInt(page));
                    }else {
                        this.page = parseInt(page);
                    }
                }
            },
            initList: function(){
                let $content = this.content;

                $content.forEach(data => {

                    if( data.show === undefined ) {
                        data.show = true;
                    }

                    if( data.sn === undefined ) {
                        data.sn = this.$okaTool.getUUID();
                    }
                });
            },
            initTable: function(){

                if( this.rememberHistory ) {
                    this.initList();
                }
            }
        },
        created: function(){
            this.initList();
        }
    }
</script>

<style scoped lang="scss">

</style>
